import React, { useState } from "react";

import "./ToggleSwitch.css";

export default function ToggleSwitch({ label }) {
  const [checked, setChecked] = useState(false);
  return (
    <div className="switch_wrapper">
      <label className="switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <span className="slider round"></span>
      </label>
      <span className="label_text">{label}</span>
    </div>
  );
}
